import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

const DISMISS_KEY = "pwa_install_dismissed_v1";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Already installed / standalone → never show
    const standalone =
      window.matchMedia?.("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (standalone) return;

    if (localStorage.getItem(DISMISS_KEY)) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const choice = await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
    if (choice.outcome !== "accepted") {
      localStorage.setItem(DISMISS_KEY, "1");
    }
  };

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  if (!visible) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed inset-x-3 z-[60] bottom-20 md:bottom-6 md:left-auto md:right-6 md:inset-x-auto md:max-w-sm glass rounded-2xl shimmer-border p-4 shadow-2xl border border-amber-200"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl chrome flex items-center justify-center shrink-0">
          <DownloadSimple size={18} weight="duotone" className="text-amber-600" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-heading font-bold text-sm">Install PayTrack</div>
          <p className="text-xs text-slate-600 mt-0.5 leading-snug">
            Add it to your home screen for a full-screen, app-like experience with push notifications.
          </p>
          <div className="mt-3 flex items-center gap-2">
            <button
              data-testid="install-prompt-accept"
              onClick={install}
              className="amber-pill inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-xs font-semibold"
            >
              Install
            </button>
            <button
              data-testid="install-prompt-dismiss"
              onClick={dismiss}
              className="text-xs text-slate-600 hover:text-slate-900 px-2 py-1"
            >
              Not now
            </button>
          </div>
        </div>
        <button
          aria-label="Close"
          onClick={dismiss}
          className="p-1 text-slate-500 hover:text-slate-800 shrink-0"
        >
          <X size={14} weight="bold" />
        </button>
      </div>
    </div>
  );
}
